import {Component, inject, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule, NgForm} from '@angular/forms';
import {PasswordValidationDirective} from '../../../auth/validation/directives/password-validation-directive';
import {AuthService} from '../../../auth/services/auth-service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';

@Component({
  selector: 'app-change-password-component',
  imports: [
    FormsModule,
    PasswordValidationDirective
  ],
  templateUrl: './change-password-component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './change-password-component.scss'
})
export class ChangePasswordComponent implements OnDestroy {

  private subscription: Subscription | null = null;
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  error: string | undefined;
  successMessage: string | undefined;
  loading = false;

  oldPassword = '';
  newPassword = '';
  confirmation = '';

  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);

  get passwordsMismatch(): boolean {
    return this.confirmation.length > 0 && this.newPassword !== this.confirmation;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
    }
  }

  save(form: NgForm) {
    this.error = undefined;
    if (form.valid && !this.passwordsMismatch && !this.loading) {
      this.loading = true;
      this.subscription = this.authService.changePassword(this.oldPassword, this.newPassword)
        .subscribe(result => {
          if (result.data) {
            this.successMessage = 'Вы сменили пароль. Вы будете перенаправлены на страницу логина.';
            this.timeoutId = setTimeout(() => {
              this.authService.logout().subscribe(() => {
                this.router.navigate(['/login']);
              });
            }, 3000);
          } else {
            this.error = result.error;
            this.loading = false;
          }
        });
    }
  }
}
